//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import Autocomplete from 'vue2-autocomplete-js';

import uniqid from 'uniqid';
import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'


const stringOptions = [
  'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
  ].reduce((acc, opt) => {
  for (let i = 1; i <= 5; i++) {
    acc.push(opt + ' ' + i)
  }
  return acc
}, [])

export default {
    components: {
          Autocomplete,
    },  
    data () {
        // const string_prov = this.$store.state.option_provinsi
        return {
            // opt_provinsi: string_prov,
            current: 3,

            // mdl_add   : false,
            // mdl_edit  : false,
            dense: true,
            nama_prov:'',
            form : {
              id : '',
              m_provinsi : '',
              m_kabupaten : '',
              kd_kabupaten : '',
              uraian : '',
              createdAt : '',
              uniqid : ''
            },

            list_data : [],

            page_limit : 8,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,
            token : localStorage.token,

            UMUM : UMUM,
            WILAYAH : WILAYAH,
        }
    },
    methods: {
      getView : function(){
      // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_DATAMASTER_KAB_KOTA + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value
            })
          })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                console.log(res_data);
          });
      },


      addData : function(number) {
        this.form.uniqid = uniqid();
        this.form.id = this.form.uniqid;
        this.form.m_kabupaten = this.form.uniqid;
        this.form.createdAt = UMUM.NOW();
        fetch(this.$store.state.url.URL_DATAMASTER_KAB_KOTA + "addData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.$store.commit('notif_berhasil')
            this.getView();
        });


      },


      editData : function(){
        fetch(this.$store.state.url.URL_DATAMASTER_KAB_KOTA + "editData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.$store.commit('notif_edit');
            this.getView();
        });
      },

      removeData : function(data){
        fetch(this.$store.state.url.URL_DATAMASTER_KAB_KOTA + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(data)
        }).then(res_data => {
            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        });

      },
      selectData : function(data){
          this.form.id = data.m_kabupaten.id;
          this.form.m_provinsi = data.m_kabupaten.m_provinsi;
          this.form.m_kabupaten = data.m_kabupaten.m_kabupaten;
          this.form.kd_kabupaten = data.m_kabupaten.kd_kabupaten;
          this.form.uraian = data.m_kabupaten.uraian;
          this.form.createdAt = data.m_kabupaten.createdAt;
          this.form.uniqid = data.m_kabupaten.uniqid;

          this.nama_prov = data.m_provinsi.uraian;

          // console.log('select_data= ' +data.m_kabupaten.m_provinsi);
 

      },

      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },

          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },

          indexing : function(index){
              var idx = ((this.page_first-1)*this.page_limit)+index
              return idx
          },
          // myFilter (terms, obj) {
          //   return obj.label.toLowerCase().indexOf(terms) > -1
          // }, 




      // ====================================== PAGINATE ====================================




      notif_berhasil () { 
        this.$q.notify({
          message: "Data berhasil dimasukan",
          color: 'green',
          icon: 'fa fa-check',
          timeout: 500,
        })
      },
      notif_berhasil_menghapus () { 
        this.$q.notify({
          message: 'Berhasil menghapus data',
          color: 'green',
          icon: 'fa fa-check',
          timeout: 500,
        })
      },
      notif_edit () { 
        this.$q.notify({
          message: 'Berhasil mengedit data',
          color: 'green',
          icon: 'fa fa-check',
          timeout: 500,
        })
      },
      notif_gagal () {
        this.$q.notify({
          message: this.pesanGagal,
          color: 'red',
          icon: 'fa fa-exclamation-triangle',
          timeout: 500,
        })
      },
 
      renderChild(data) {
          return `
          <span><b>${data.kd_provinsi}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      }, 

      get_auto(data){
        console.log(data.m_provinsi); 
        this.form.m_provinsi = data.m_provinsi 
        // console.log(data.uraian); 
        this.nama_prov = data.uraian 
      },         
      abortFilterFn () {
        // console.log('delayed filter aborted')
      },

      CariData: function (){
        this.getView();
      },

    },
    mounted (){
      this.CariData();
    },
}
